import { Alert, Button } from 'react-bootstrap';

import { verdictErrorMessage } from './incidentsErrorMessage';
import type { RequestError } from './loadable';

type IncidentActionsViewProps = {
  closed: boolean;
  acted: boolean;
  refusal: RequestError | undefined;
  onCloseIncident: () => void;
};

function IncidentActionsView({
  closed,
  acted,
  refusal,
  onCloseIncident,
}: IncidentActionsViewProps): JSX.Element | null {
  const nothingLeftToShow = closed && refusal === undefined;
  if (nothingLeftToShow) {
    return null;
  }

  return (
    <div className="diagnostics-detail-verdicts">
      {refusal !== undefined && <Alert variant="danger">{verdictErrorMessage(refusal)}</Alert>}
      {!closed && (
        <Button variant="outline-secondary" disabled={acted} onClick={onCloseIncident}>
          Close
        </Button>
      )}
    </div>
  );
}

export default IncidentActionsView;
